import type { Components, Theme } from "@mui/material/styles";

export const PLAYER_COMPONENT_OVERRIDES: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        WebkitTextSizeAdjust: "100%",
        textSizeAdjust: "100%",
        backgroundColor: "var(--bw-palette-background-default)",
      },
      body: {
        margin: 0,
        minWidth: 320,
        backgroundColor: "var(--bw-palette-background-default)",
        color: "var(--bw-palette-semantic-onSurface)",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      },
      "#root": {
        minHeight: "100dvh",
      },
      a: {
        color: "inherit",
      },
    },
  },
  MuiAppBar: {
    defaultProps: {
      color: "transparent",
      elevation: 0,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.vars.palette.semantic.onSurface,
        backgroundColor: theme.vars.palette.semantic.surface,
        backgroundImage: "none",
        borderBottom: `1px solid ${theme.vars.palette.divider}`,
      }),
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
      outlined: ({ theme }) => ({
        borderColor: theme.vars.palette.divider,
      }),
    },
  },
  MuiCard: {
    defaultProps: {
      variant: "outlined",
    },
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundImage: "none",
        borderColor: theme.vars.palette.divider,
      }),
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
  },
  MuiBottomNavigation: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 64,
        backgroundColor: theme.vars.palette.semantic.surface,
      }),
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        color: theme.vars.palette.semantic.onSurface,
        backgroundColor: theme.vars.palette.semantic.surface,
        backgroundImage: "none",
        borderColor: theme.vars.palette.divider,
      }),
    },
  },
  MuiDialog: {
    defaultProps: {
      fullWidth: true,
    },
    styleOverrides: {
      paper: {
        backgroundImage: "none",
      },
    },
  },
};
